module.exports = __webpack_public_path__ + "img/link_plus.9524e6a8.svg";